import React, { Component } from "react";

import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import $ from "jquery";
import TipoOptionForm from "./TipoOptionForm";
import queryString from "query-string";
import services from "../../../services";
import { toast } from "react-toastify";
import ClassGrid from "./Grid1/ClassGrid";
import ClassGrid10 from "./Grid10/ClassGrid10";
var lengthDadosVasilhas;
var DetalhesVasilhas =  "undefined"
var indexComponent = 0
var idVasilhaGrid = 0
var otherThis;
const Request = [
    "IDVasilha",
    "IDTipoVasilha",
    "NumeroVasilha",
    "IDInstalacaoVinica",
    "codEntidade",
    "Localizacao",
  
    "Observacoes",
    "CapacidadeComunicada",
    "CapacidadeCalculada",
    "Dimensao1",
    "Dimensao2",
    "Dimensao3",
    "Dimensao4",
    "Dimensao5"
];
const Request2 = [
    "IDVasilha",
    "IDTipoVasilha",
    "NumeroVasilha",
    "IDInstalacaoVinica",
    "codEntidade",
    "Localizacao",
  
    "Observacoes",
    "CapacidadeComunicada",
    "CapacidadeCalculada",
    "Dimensao1",
    "Dimensao2",
    "Dimensao3",
    "Dimensao4",
    "Dimensao5",

    "Falta",
    "DiametroVinho",
    "localMedicao",
    "Quantidade",
    "TipoVasilha"
];
const requiredFields = [
    "IDTipoVasilha", //
    "IDInstalacaoVinica",
    "NumeroVasilha",
    // "codEntidade",//
    // "Localizacao", //
    
    "CapacidadeComunicada",
    "CapacidadeCalculada", //
];
var vasilhaCalculo = []
var DadosVasilha;
class Inserirvasilha extends Component {
    constructor() {
        super();

        this.state = {
            result: "",
            tipoOptionValue: "",
            data: {},
            IDVasilha : "",
            NumeroVasilha: "",
            id: "",
           // calculationResult: "",
            tipoCurrent: "",
            Observacoes: "",
            idVasilha: 0,
            numparant: "",
            capacity: "",
            user: "",
            Localizacao: "",
            nifArray: [],
            vasilahDropdownData: [],
            requiredField: {
                numparant: false,
                // capacity: false,
                // Obser: false,
                // calculationResult: false,
                user: false,
                Localizacao: "",
            },
            isCalculationOk: true,
            row: {},
            codEntidade: "",
            contaQuantidade: 0
            
        };
    }
    static getEntrouPelaGrid = (e) => {
        DadosVasilha = e
        if(DadosVasilha.length > 1){
            if( otherThis != null){
                otherThis.componentDidMount()
            }
           
        }
    }

    componentDidMount() {
        otherThis = this;
        
        (async () => {   
            var idTipoVasilhaGrid = 0
            DetalhesVasilhas = "undefined"
           
            DadosVasilha.map((key) => { 
                console.log(key)
                if(key.inEdit === true){
                    if(key.Tipo_Vasilha != undefined){
                        idTipoVasilhaGrid = key.Tipo_Vasilha.value  
                        idVasilhaGrid = key.N_Vasilha_granel == undefined ? key.N_Vasilha.value : key.N_Vasilha_granel.value

                        DetalhesVasilhas = (key)
                    } 
                }
            })
        
            var vasilhaSelecionada = $("#id-DropDownCellTipoVasilha .k-input")[0].innerHTML
            var codEntidade = parseInt($("#instal_vinica_auto :selected").val().split("!")[1])
            console.log(this.props)

            this.setState({
                codEntidade: codEntidade,
            })
            var  dataTokenidVasilha = {"IDVasilha": idVasilhaGrid}
            DetalhesVasilhas = await services.apiCall.requestApi(
                "InstalacaoVinica/GetVasilha",
                dataTokenidVasilha,
                "get"
            ); 
            console.log(DetalhesVasilhas)
            var  dataToken = {}
            var Detalhes = await services.apiCall.requestApi(
                "/InstalacaoVinica/GetAllTipoVasilha",
                dataToken,
                "get"
            ); 
            
            var strHTML = "<option value='0' selected>Selecione...</option>";
            for (let index = 0; index < Detalhes.length; index++) {
              var TipoVasilha = Detalhes[index].tipoVasilha;
              var idTipoVasilha = Detalhes[index].idTipoVasilha;
              
            strHTML = strHTML + "<option value='" + idTipoVasilha + "'>" + TipoVasilha + "</option>";
            }

             $("#tipoVasilhas").html(strHTML)
            // if (Object.keys(this.props.row).length > 0) {
             
            // }
            if (DetalhesVasilhas !=  "undefined") {
                $(".k-textbox-container").removeClass("k-state-empty")
                $("#tipoVasilhas option[value='" + DetalhesVasilhas.idTipoVasilha + "']").attr("selected","selected");
                $("#tipoVasilhas").attr("disabled" , true)
                 $("#Localizacao").val(DetalhesVasilhas.localizacao)
                 $("#numeroVasilha").val(DetalhesVasilhas.numeroVasilha)
                 $("#numeroVasilha").attr("disabled" , true)
                 $("#capacidadeComunicada").val(DetalhesVasilhas.capacidadeComunicada)
                 $("#Observacoes").val(DetalhesVasilhas.observacoes)
                 $("#capac").val(DetalhesVasilhas.capacidadeCalculada)
                 $("#Falta").val("")
                 $("#DiametroVinho").val("")
                 $("#Quantidade").val("")
                 $("#localMedicao option[value='" + 0 + "']").attr("selected","selected");
                 $( "#tipoVasilhas" ).trigger( "change" )
                 this.handleChange("TipoVasilha")
                
                //$("#tipoVasilhas"[this.props.row.tipoVasilha]).attr("selected",true)
               // console.log("rowwww issss", this.props.row);
                indexComponent = 1
            } else if(indexComponent == 0) {
                this.setDefaulltState();
               $("#tipoVasilhas option[value='" + 0 + "']").attr("selected","selected");
               indexComponent = 1
            }
        })(); 
        
        // TipoOptionForm.GetDimencoesCampos(DetalhesVasilhas);
    }

    componentDidUpdate(prevProps, prevState) {
        
       if(DetalhesVasilhas !=  "undefined"){
       
            $(".k-textbox-container").removeClass("k-state-empty")
            $("#tipoVasilhas option[value='" + DetalhesVasilhas.idTipoVasilha + "']").attr("selected","selected");
            $("#tipoVasilhas").attr("disabled" , true)
            $("#Localizacao").val(DetalhesVasilhas.localizacao)
            $("#numeroVasilha").val(DetalhesVasilhas.numeroVasilha)
            $("#numeroVasilha").attr("disabled" , true)
            $("#capacidadeComunicada").val(DetalhesVasilhas.capacidadeComunicada)
            $("#Observacoes").val(DetalhesVasilhas.observacoes)
            $("#0").val("")
            $("#1").val("")
            $("#2").val("")
            $("#3").val("")
            $("#4").val("")
            $("#0").val(DetalhesVasilhas.dimensao1)
            $("#1").val(DetalhesVasilhas.dimensao2)
            $("#2").val(DetalhesVasilhas.dimensao3)
            $("#3").val(DetalhesVasilhas.dimensao4)
            $("#4").val(DetalhesVasilhas.dimensao5)
            $("#capac").val(DetalhesVasilhas.capacidadeCalculada)
            //$("#Quantidade").val("")
            //$("#Quantidade").val(this.state.contaQuantidade)
            $("#Falta").val("")
            $("#DiametroVinho").val("")
            $("#localMedicao option[value='" + 0 + "']").attr("selected","selected");
           
        }
        (async () => {   
            var idTipoVasilhaGrid = 0
            DetalhesVasilhas = "undefined"
           
            DadosVasilha.map((key) => { 
                console.log(key)
                if(key.inEdit === true){
                    if(key.Tipo_Vasilha != undefined){
                        idTipoVasilhaGrid = key.Tipo_Vasilha.value  
                        idVasilhaGrid = key.N_Vasilha_granel == undefined ? key.N_Vasilha.value : key.N_Vasilha_granel.value

                        DetalhesVasilhas = (key)
                    } 
                }
            })
        
            
            var  dataTokenidVasilha = {"IDVasilha": idVasilhaGrid}
            DetalhesVasilhas = await services.apiCall.requestApi(
                "InstalacaoVinica/GetVasilha",
                dataTokenidVasilha,
                "get"
            ); 
            console.log(DetalhesVasilhas)

            if (prevProps.DadosVasilha !== this.props.DadosVasilha && this.props.DadosVasilha) {
                TipoOptionForm.GetDimencoesCampos(DetalhesVasilhas);
            }
            
        })(); 
       
    }

    getVasilahDropdown = () => {
        let { displayData } = this.props;
        if (displayData.Instalação.length === 0) {
            return displayData.Utilizadores;
        } else {
            let arr = displayData.Utilizadores.filter(
                (Util) => Util.nif != displayData.Instalação[0].nif
            );
            return [...arr, ...displayData.Instalação];
        }
    };

    setRowState = (row) => {
        this.setState(
            {
                user: row.codEntidade,
                Localizacao: row.localizacao,
                //numparant: row.matricula,
                capacity: row.capacidadeComunicada,
                Obser: row.observacoes,
                IDVasilha: row.idVasilha,
                //calculationResult: row.capacidadeCalculada,
            },
            () => {
                this.setTipoList(
                    this.state.row["tipoVasilha"]
                        ? this.state.row["tipoVasilha"].toString()
                        : null
                );
            }
        );
    };

    setDefaulltState = () => {
        this.setState({
            user: "",
            Localizacao: "",
            numparant: "",
            capacity: 0,
            Obser: "",
            IDVasilha: 0,
            tipoOptionValue: "",
           // calculationResult: 0,
            requiredFieldsToggle: false,
            tipoVasilha: "",
        });
    };

    // tipoCal=(e)=>{

    //      rend = async()=>{

    //             let obj =

    //          let res = await services.apiCall.requestApi("/allservice/TipoVasilha/GetAll",combolistrequest,"post")
    //     }
    //  }
    onClick = (button) => {
        if (button === "=") {
            this.calculate();
        } else if (button === "C") {
            this.reset();
        } else if (button === "CE") {
            this.backspace();
        } else {
            this.setState({
                result: this.state.result + button,
            });
        }
    };

    calculate = () => {
        try {
            this.setState({
                // eslint-disable-next-line
                result: (eval(this.state.result) || "") + "",
            });
        } catch (e) {
            this.setState({
                result: "error",
            });
        }
    };

    reset = () => {
        this.setState({
            result: "",
        });
    };

    checkFormatOfInput = (e) => {
        let checkIfNum = false;
        if (e.key !== undefined) {
            checkIfNum =
                e.key === "e" ||
                e.key === "+" ||
                e.key === "-" ||
                e.key === "E";
        } else if (e.keyCode !== undefined) {
            checkIfNum =
                e.keyCode === 69 || e.keyCode === 187 || e.keyCode === 189;
        }
        return checkIfNum && e.preventDefault();
    };

    backspace = () => {
        this.setState({
            result: this.state.result.slice(0, -1),
        });
    };
    capitaliseKey = (key, position) => {
        return (
            key.substr(0, position).toUpperCase() +
            key.substr(position, key.length)
        );
    };

    calFormValue = (data, id) => {
        // if(id!=this.state.id) this.state.capacity=0;
        this.setState({
            data,
            id,
            isCalculationOk: false,
        });
    };
    static getVasilhasCalculation = async (datavasilha) =>{
        if(datavasilha != undefined){vasilhaCalculo = datavasilha}
    }
    getCalculation = async () => {
        // let res = this.state.capacity
        var medida1 = $("#0").val() != undefined &&  $("#0").val() != ""  ? $("#0").val() : "-"
        var medida2 = $("#1").val() != undefined &&  $("#1").val() != ""  ? $("#1").val() : "-"
        var medida3 = $("#2").val() != undefined &&  $("#2").val() != ""  ? $("#2").val() : "-"
        var medida4 = $("#3").val() != undefined &&  $("#3").val() != ""  ? $("#3").val() : "-"
        var medida5 = $("#4").val() != undefined &&  $("#4").val() != ""  ? $("#4").val() : "-"
        var dataarray = []
        dataarray.push(medida1 ,medida2,  medida3 , medida4 , medida5)
       
        var { data, id } = { ...this.state } 
        data = dataarray 
        let newData = { TipoVasilha: id };
        let res = "";
        if(data != undefined && data != null){
            // if(vasilhaCalculo.length > 0){
            //     data = vasilhaCalculo
            // }
            Object.keys(data).map((key) => {
                //console.log("KEY: ", parseInt(key) + 1 )
                let idx = parseInt(key) + 1
                let preKey = "Medida" + idx; 
                let newKey = this.capitaliseKey(preKey, 1);
                let res = 0;
    
                if (!isNaN(+data[key])){
                    res = +data[key]
                }
    
                newData[newKey] = res;
            });
            
        //console.log('TipoCurrent value is.........    ', this.state.tipoCurrent)
        // if(this.state.tipoCurrent.)
            if (this.state.tipoCurrent.calculo !== "Capacidade") {
                newData["TipoVasilha"] = parseInt($("#tipoVasilhas :selected").val())
                res = await services.apiCall.requestApi(
                    "/InstalacaoVinica/GetVasilhaFormulaCalc",
                    newData,
                    "post"
                );
            } else res = this.state.capacity;
            console.log("my resssssssss", res);
            let { requiredField } = this.state;
            if (res) {
                requiredField["calculationResult"] = false;
                $(".k-textbox-container").removeClass("k-state-empty")
                $("#capac").val(res)
            }

            
        }
       

    };

    handleChange = (e , idTipoVasilha) => {
       // console.log("the option is.....", e.target.value);
        if(e == "TipoVasilha"){
            var name = "TipoVasilha"
            var keyCode = new Date();
            var checkvalue =  DetalhesVasilhas.idTipoVasilha;
        }else{
            var name = e.target.name;
            var keyCode = e.nativeEvent.data;
            var checkvalue = e.target.value;    
        }
       
        let { requiredField } = this.state;
        if (Object.keys(requiredField).includes(name))
            requiredField[name] = false;

        if (checkvalue === "") {
            requiredField[name] = true;
        }

        console.log("CheckValue", name, checkvalue);
        let currData = "";
        if (name == "capacity") {
            if (isNaN(keyCode) == false || keyCode == ".") {
                let decimalsep = checkvalue.indexOf(".");
                if (decimalsep >= 1 && checkvalue.length <= 12) {
                    currData = checkvalue;
                } else if (decimalsep == -1 && checkvalue.length <= 12) {
                    currData = checkvalue;
                } else if (checkvalue.length > 12) {
                    return;
                }
            }

            this.setState({ [e.target.name]: currData });
        } else if (name == "Obser") {
            let { Obser } = this.state;
            Obser = e.target.value;
            this.setState({
                Obser,
            });
        
        } else if (name == "numeroVasilha") {
            let { NumeroVasilha } = this.state;
            NumeroVasilha = e.target.value;
            this.setState({
                NumeroVasilha,
            });
        
        } else {
            var idVas = parseInt($("#tipoVasilhas :selected").val())
            console.log(this.props)
            let tipoCurrentArr = this.props.tipoOptionList.filter((object) => {
                console.log(tipoCurrentArr , object , "ENCONTAR VASILHA")
                if (checkvalue == object.codTipoVasilha) {
                    return true;
                } else return false;
            });
            console.log("yes this is the one......", tipoCurrentArr);
            var idVas = $("#tipoVasilhas :selected").val()
            var TipoVas = $("#tipoVasilhas :selected").text()
            this.setState({
                [name]: checkvalue,
                tipoCurrent: tipoCurrentArr[0],
                //calculationResult: 0,
                idVasilha : idVas
            },
            () => {
                this.setTipoList(
                    TipoVas
                );
            });
            
        
        }
    };

    handleChangeNewEndPoint= (e) => {
        (async () => {   
            var Falta = $("#Falta").val()
            var NovoDiametro = $("#DiametroVinho").val()
            var LocalMedicao = $("#localMedicao :selected").val()
            var IDVasilha = idVasilhaGrid
            if(NovoDiametro == "" ){
                NovoDiametro = "0"
            }
            if(Falta != "" && NovoDiametro != "" && LocalMedicao != "" && IDVasilha != ""){
                var  dataTokenidVasilha = {"Falta": parseFloat(Falta) , "NovoDiametro" : parseFloat(NovoDiametro) , "LocalMedicao": parseFloat(LocalMedicao) , "IDVasilha" : parseFloat(IDVasilha)}
                var  contaQuantidade = await services.apiCall.requestApi(
                        "Fiscalizacao/CalcVasilhaFalta",
                        dataTokenidVasilha,
                        "get"
                    ); 
                $("#Quantidade").val(contaQuantidade)
                console.log(contaQuantidade)
                this.state.contaQuantidade = contaQuantidade
            }
           
        })();
    }

    canclePopup = () => {
        ////console.log("OKOK");
        this.setState({
            forFilter: {},
            form: {},
        });
        $(".left-popup").trigger("click");
    };

    sortFunction = (list) => {
        if (Array.isArray(list) && list.length > 0) {
            return (
                //sort(){name:roll}{}
                list.sort((a, b) => {
                    if (a.name > b.name) {
                        return 1;
                    } else {
                        return -1;
                    }
                })
            );
        }
    };

    updateTipoCurrent = (row) => {
        this.setState({
            tipoCurrent: row,
        });
    };

    insertVasilha = async () => {
        let Request = this.createRequestBody();
        let Request2 = this.createRequestBody2();
        let link;
        let isCreated = null;
        let { isValid, validCapacity } = this.checkMandatoryFields(Request);
        console.log("800 capacity", validCapacity);
        if (!isValid || !validCapacity) {
            toast.error("Existem campos obrigatórios por preencher");
            this.setState({
                requiredFieldsToggle: true,
            });
            return;
        }
            link = "InstalacaoVinica/UpdateVasilha";
            isCreated = false;
        
        console.log("Reqquest", Request);
        let res = await services.apiCall.requestApi(link, Request, "post");
        if (res) {
            //await this.props.getAllVasilha();
            //this.props.closePopup();
            //this.props.setStateDate();
            if (isCreated)
                toast.success("Vasilha associada à instalação vínica com sucesso!");
            else 
                toast.success("Vasilha editada com sucesso!");
                if($("#tipo_auto :selected").val() == '24'){
                    ClassGrid10.ClassGrid10.itemChangeModal(Request2)
                }else{
                    ClassGrid.ClassGrid.itemChangeModal(Request2)
                }
                
                $(".left-popup").trigger('click');

        } else {
            toast.error("Não foi possível adicionar a vasilha");
           // this.props.closePopup();
        }
    };

    checkMandatoryFields = (obj) => {
        console.log("Obj is 800", obj);
        let isValid = true;
        let validCapacity = false;
        requiredFields.map((key) => {
            if (key === "CapacidadeCalculada" || key === "CapacidadeComunicada") 
            {
                if (!!obj[key] && !validCapacity) {
                    validCapacity = true;
                }

            } else if (obj[key] === null) {
                isValid = false;
            }
        });
        return { isValid, validCapacity };
    };

    // preenchimento da drop
    setTipoList = (tipoVasilha) => {
        if (tipoVasilha === null) return;
        let tipoCurrentArr = this.props.tipoOptionList.filter((object) => {
            if (tipoVasilha == object.tipoVasilha) {
                return true;
            } else return false;
        });
        console.log("yes this is the one......", tipoCurrentArr);
        this.setState({
            ["tipoOptionValue"]: tipoVasilha,
            tipoCurrent: tipoCurrentArr[0],
            //calculationResult:0
        });

        
    };

    createRequestBody = () => {
        let payLoad = {};

        Request.map((key) => {
            console.log(this.state)
            if (key === "IDVasilha") {
                payLoad[key] = idVasilhaGrid;
            } else if (key === "IDTipoVasilha") {
                payLoad[key] = parseInt($("#tipoVasilhas").val()) || null
            } else if (key === "codEntidade") {
                payLoad[key] = String(this.state.codEntidade) || null;
            } else if (key === "IDInstalacaoVinica") {
                payLoad[key] = parseInt(this.props.IDInstalacaoVinica) || null;
            } else if (key === "Localizacao") {
                payLoad[key] = $("#Localizacao").val() || null;
            } else if (key === "NumeroVasilha") {
                payLoad[key] = $("#numeroVasilha").val() || null;
            }  else if (key === "Observacoes") {
                payLoad[key] = $("#Observacoes").val() || null;
            } else if (key === "CapacidadeComunicada") {
                payLoad[key] = parseFloat($("#capacidadeComunicada").val()) || null;
                 
            } else if (key === "CapacidadeCalculada") {
                payLoad[key] = parseFloat($("#capac").val()) || 0;
            } else if (key === "Dimensao1") {
                payLoad[key] = $("#0").val() != "" && $("#0").val() != "-" && $("#0").val() != undefined
                    ? parseFloat($("#0").val())
                    : 0.0;
            } else if (key === "Dimensao2") {
                payLoad[key] =  $("#1").val() != "" && $("#1").val() != "-" && $("#1").val() != undefined
                ? parseFloat($("#1").val())
                : 0.0;
            } else if (key === "Dimensao3") {
                payLoad[key] = $("#2").val() != "" && $("#2").val() != "-" && $("#2").val() != undefined
                ? parseFloat($("#2").val())
                : 0.0;
            } else if (key === "Dimensao4") {
                payLoad[key] = $("#3").val() != "" && $("#3").val() != "-" && $("#3").val() != undefined
                ? parseFloat($("#3").val())
                : 0.0;
            } else if (key === "Dimensao5") {
                payLoad[key] = $("#4").val() != "" && $("#4").val() != "-" && $("#4").val() != undefined
                ? parseFloat($("#4").val())
                : 0.0;
            }
        });

        return payLoad;
    };
    createRequestBody2 = () => {
        let payLoad = {};

        Request2.map((key) => {
            console.log(this.state)
            if (key === "IDVasilha") {
                payLoad[key] = idVasilhaGrid;
            } else if (key === "IDTipoVasilha") {
                payLoad[key] = parseInt($("#tipoVasilhas :selected").val()) || null
            } else if (key === "codEntidade") {
                payLoad[key] = this.state.codEntidade || null;
            } else if (key === "IDInstalacaoVinica") {
                payLoad[key] = parseInt(this.props.IDInstalacaoVinica) || null;
            } else if (key === "Localizacao") {
                payLoad[key] = $("#Localizacao").val() || null;
            } else if (key === "NumeroVasilha") {
                payLoad[key] = $("#numeroVasilha").val() || null;
            }  else if (key === "Observacoes") {
                payLoad[key] = $("#Observacoes").val() || null;
            } else if (key === "CapacidadeComunicada") {
                payLoad[key] = parseFloat($("#capacidadeComunicada").val()) || 0;
                 
            } else if (key === "CapacidadeCalculada") {
                payLoad[key] = parseFloat($("#capac").val()) || 0;
            } else if (key === "Dimensao1") {
                payLoad[key] = $("#0").val() != "" && $("#0").val() != "-" && $("#0").val() != undefined
                    ? parseFloat($("#0").val())
                    : 0.0;
            } else if (key === "Dimensao2") {
                payLoad[key] =  $("#1").val() != "" && $("#1").val() != "-" && $("#1").val() != undefined
                ? parseFloat($("#1").val())
                : 0.0;
            } else if (key === "Dimensao3") {
                payLoad[key] = $("#2").val() != "" && $("#2").val() != "-" && $("#2").val() != undefined
                ? parseFloat($("#2").val())
                : 0.0;
            } else if (key === "Dimensao4") {
                payLoad[key] = $("#3").val() != "" && $("#3").val() != "-" && $("#3").val() != undefined
                ? parseFloat($("#3").val())
                : 0.0;
            } else if (key === "Dimensao5") {
                payLoad[key] = $("#4").val() != "" && $("#4").val() != "-" && $("#4").val() != undefined
                ? parseFloat($("#4").val())
                : 0.0;
            }else if (key === "Falta") {
                payLoad[key] = parseFloat($("#Falta").val()) || 0
            }else if (key === "DiametroVinho") {
                payLoad[key] = parseFloat($("#DiametroVinho").val()) || 0
            }else if (key === "localMedicao") {
                payLoad[key] = parseFloat($("#localMedicao :selected").val()) || null
            }else if (key === "Quantidade") {
                payLoad[key] = parseFloat($("#Quantidade").val()) || 0
            }else if (key === "TipoVasilha") {
                payLoad[key] = $("#tipoVasilhas :selected").text() || null
            }
        });

        return payLoad;
    };
    handleSubmit = () => {
        this.insertVasilha();
    };

    /*  Para renderizar o conteúdo html da página   */

    render() {
        // console.log("propsfromWizard",this.props)
        let { tipoOptionList } = this.props;
       
        //codTipoVasilha
        console.log("Inserivisila Propped ", tipoOptionList);
        let params = queryString.parse(window.location.search);
        let id = params.id ? params.id : "";

        var idVas = parseInt($("#tipoVasilhas :selected").val())
        $("#tipoVasilhas option[value='" + idVas + "']").attr("selected","selected");
           
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <span
                        className="modal-title bold"
                        style={{ fontSize: "large" }}
                    >
                        <b>{!id ? "Cálculos Vasilha" : "Cálculos Vasilha"}</b>
                    </span>
                    <Button
                        className="success btn-ivdp-primary l-350 mr-3"
                        primary={true}
                        onClick={() => this.handleSubmit()}
                    >
                        Gravar
                    </Button>
                    <Button
                        className="remoove k-primary btn-ivdp-secondary btn-theme ml-1 mr-2"
                        onClick={() => this.canclePopup()}
                    >
                        Cancelar
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="model-body">
                        {id ? (
                            <>
                                <div className="right-tab">
                                    <ul className="nav nav-tabs d-flex text-center">
                                        <li className="nav-item flex-fill">
                                            <a
                                                className="nav-link active  selos-nav right-tab"
                                                data-toggle="tab"
                                                href="#Detalhes"
                                            >
                                                Detalhes
                                            </a>
                                        </li>
                                        <li className="nav-item flex-fill">
                                            <a
                                                className="nav-link  selos-nav right-tab"
                                                data-toggle="tab"
                                                href="#Histórico"
                                            >
                                                Histórico
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane active container"
                                        id="Detalhes"
                                    >
                                        <div className="row mt-3">
                                            <div className="col-md-12">
                                                <label className="mb-0">
                                                    <strong>Armazém</strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>Tipo</strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>
                                                        Tipo de material
                                                    </strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>
                                                        Capacidade Comunicada
                                                    </strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>número</strong>
                                                </label>
                                                <p>#####</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <TipoOptionForm
                                                    viewFor={
                                                        this.state
                                                            .tipoOptionValue
                                                    }
                                                    id={id}
                                                    data={this.props.data || {}}
                                                    calFormValue={(
                                                        data,
                                                        option
                                                    ) =>
                                                        this.calFormValue(
                                                            data,
                                                            option
                                                        )
                                                    }
                                                    tipoOptionList={
                                                        tipoOptionList
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <div className="input-box active-grey" style={{margin: "5px"}}>
                                                    <label className="input-label">
                                                        Observações
                                                    </label>
                                                    <textarea
                                                        className="form-control heigh-auto"
                                                        rows="3"
                                                        name="Obser"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane container"
                                        id="Histórico"
                                    >
                                        <div className="row mt-3">
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>
                                                        Capacidade Comunicada
                                                    </strong>
                                                </label>
                                                <p>Lorem Ipsum</p>
                                            </div>
                                            <div className="col-md-12 my-2">
                                                <label className="mb-0">
                                                    <strong>
                                                        Data de comunicação
                                                    </strong>
                                                </label>
                                                <p>XX-XX-XXXX</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="row">
                                    {/* <div className="col-md-8"  style={{marginBottom:"-4px"}}>
                                        <div className="input-box active-grey drop-down-box">
                                            <label className="input-label">Entidade proprietária da vasilha</label>
                                            <select className="custome-drop-down" name="user" value={this.state.user} onChange={(e)=>this.handleChange(e)} placeholder="select value">
                                            <option disabled></option>
                                            {
                                                this.getVasilahDropdown().map((option,index)=>(
                                                  <option key={index} value={option.codEntidade}>{option.nome}</option>  
                                                ))
                                            }
                                            </select>
                                            {
                                                this.state.requiredFieldsToggle && 
                                                !this.state.user &&
                                                <span className="text-danger">Campo obrigatório</span>
                                            }
                                        </div>
                                    </div> */}
                                </div>
                                {/* <div className="row">
                                    <div
                                        className="col-md-8 "
                                        style={{ marginBottom: "-4px" }}
                                    >
                                        <div className="input-box active-grey drop-down-box" style={{margin: "5px"}}>
                                            <Input
                                                style={{ width: "100%" }}
                                                onChange={(e) =>
                                                    this.handleChange(e)
                                                }
                                                type="text"
                                                name="Localizacao"
                                                className="input-1"
                                                label="Local"
                                                id="Localizacao"
                                            />
                                            {/* {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )} */}
                                        {/* </div> */}
                                    {/* </div> */}
                                {/* </div>  */}
                                <div className="row">
                                    <div
                                        className="col-md-4"
                                        style={{ marginBottom: "-4px" }}
                                    >
                                        <div className="input-box active-grey drop-down-box" style={{margin: "5px"}}>
                                            <Input
                                                style={{ width: "100%" }}
                                                // onChange={(e) =>
                                                //     this.handleChangeNewEndPoint(e)
                                                // }
                                                // value={this.state.Localizacao}
                                                type="number"
                                                name="Falta"
                                                className="input-1"
                                                label="Falta (m)"
                                                id="Falta"
                                                step="any"
                                            />
                                            {/* {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )} */}
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-4"
                                        style={{ marginBottom: "-4px" }}
                                    >
                                        <div className="input-box active-grey drop-down-box" style={{margin: "5px"}}>
                                            <Input
                                                style={{ width: "100%" }}
                                                // onChange={(e) =>
                                                //     this.handleChangeNewEndPoint(e)
                                                // }
                                                // value={this.state.Localizacao}
                                                type="number"
                                                name="DiametroVinho"
                                                className="input-1"
                                                label="Diâmetro do vinho"
                                                id="DiametroVinho"
                                                step="any"
                                            />
                                            {/* {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )} */}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="input-box active-grey drop-down-box" style={{margin: "5px" , marginTop: "26px"}}>
                                            <label className="input-label">
                                            Local de Medição
                                            </label>
                                            <select class='custome-drop-down localMedicao' name='localMedicao' id="localMedicao"  >
                                                    <option value='0' >Selecione...</option>
                                                    <option value='1' >Cone Inferior</option>
                                                    <option value='2' >Cilindro</option>
                                                    <option value='3' >Cone Superior</option>
                                            </select>

                                            {/* {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )} */}
                                        </div>
                                    </div>
                                </div>
                               
                                
                                <div className="row align-items-center">
                                    <div className="col-md-4">
                                        <div className="input-box active-grey" style={{margin: "5px"}}>
                                            <Input
                                                style={{ width: "100%" }}
                                                className="input-1"
                                                name="numeroVasilha"
                                                type="text"
                                                label="Número"
                                                id="numeroVasilha"
                                                // onChange={(e) =>
                                                //     this.handleChange(e)
                                                // }
                                                // value={
                                                //     this.state.NumeroVasilha == "" ? this.props.row.numeroVasilha : this.state.NumeroVasilha
                                                // }
                                            />
                                            {/* {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )} */}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="input-box active-grey" style={{margin: "5px"}}>
                                            <Input
                                                style={{ width: "100%" }}
                                                className="input-1"
                                                name="capacity"
                                                id="capacidadeComunicada"
                                                type="number"
                                                //step="0.001"
                                                label="Capacidade Comunicada (L)"
                                                onChange={(e) =>
                                                    this.handleChange(e)
                                                }
                                            />
                                            {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )}
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-6 mb-3"
                                        style={{ marginBottom: "-4px" }}
                                    >
                                        <div className="input-box active-grey drop-down-box" style={{margin: "5px"}}>
                                            <Input
                                                style={{ width: "100%" }}
                                                // onChange={(e) =>
                                                //     this.handleChange(e)
                                                // }
                                                // value={this.state.Localizacao}
                                                type="number"
                                                name="Quantidade"
                                                className="input-1"
                                                label="Quantidade (L)"
                                                id="Quantidade"
                                            />
                                            {/* {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )} */}
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-6 mb-3"
                                        style={{ top: "8px" }}
                                    >
                                        <Button
                                            className="btn-ivdp-primary"
                                            onClick={() =>
                                                this.handleChangeNewEndPoint()
                                            }
                                            primary={true}
                                        >
                                            Calcular
                                        </Button>
                                    </div>

                                    {/*The dropdown not required---------------------*/}
                                    {/* <div className="col-md-12 mb-3">
                                        <div className="input-box active-grey drop-down-box">
                                            <label className="input-label">Armazém </label>
                                            <select className="custome-drop-down" onChange={(e) => this.handleChange(e)}  >
                                                <option>Selecione Armazém</option>

                                            </select>
                                        </div>
                                    </div> */}

                                    <div className="col-md-12">
                                        <div className="input-box active-grey drop-down-box" style={{margin: "5px"}}>
                                            <label className="input-label"  style={{zIndex: "1"}}>
                                                Tipo{" "}
                                            </label>
                                            <select class='custome-drop-down tipoVasilhas' name='tipoVasilhas' id="tipoVasilhas" onChange={(e) =>this.handleChange(e)} >
                                                    <option value='0'  selected disabled>Selecione...</option>
                                            </select>

                                            {/* {this.state.requiredFieldsToggle &&
                                                !this.state.Localizacao && (
                                                    <span className="text-danger">
                                                        Campo obrigatório
                                                    </span>
                                                )} */}
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-12 mb-3"
                                        style={{ top: "-5px" }}
                                    >
                                        {tipoOptionList.map((_option, i) => {
                                            //console.log("TipoOptionForm",_option)
                                            console.log(
                                                "Checkbothhhhhhhhhh",
                                                _option.tipoVasilha,
                                                this.state.tipoOptionValue
                                            );
                                            //this.setState({capacity:0})
                                            if (
                                                _option.tipoVasilha.trim() ===
                                                this.state.tipoOptionValue.trim()
                                            ) {
                                                return (
                                                    //codTipoVasilha
                                                    <TipoOptionForm
                                                            data={
                                                                this.props
                                                                    .row || {}
                                                            }
                                                            key={i}
                                                            viewFor={
                                                                this.state
                                                                    .tipoOptionValue
                                                            }
                                                            row={_option}
                                                            calFormValue={(
                                                                data,
                                                                option
                                                            ) =>
                                                                this.calFormValue(
                                                                    data,
                                                                    option
                                                                )
                                                            }
                                                        />
                                                );
                                            }
                                        })}
                                    </div>

                                    {/* <div className="col-sm-12 col-xl-6">
                                            <label className="input-label"> User</label>
                                            <select  className="custome-drop-down">
                                                <option>select option</option>
                                            </select>
                                        </div> */}

                                    <div
                                        className="col-md-6 mb-3"
                                        style={{ top: "-27px" }}
                                    >
                                        <div className="input-box active-grey" style={{margin: "5px"}}>
                                            <Input
                                                style={{ width: "100%" }}
                                                className="input-1"
                                                name="capac"
                                                id="capac"
                                                label="Capacidade (L)"
                                                type="number"
                                            />
                                            {/* {this.state.requiredField
                                                .calculationResult && (
                                                <span className="text-danger">
                                                    Campo obrigatório
                                                </span>
                                            )} */}
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-6 mb-3"
                                        style={{ top: "-17px" }}
                                    >
                                        <Button
                                            className="btn-ivdp-primary"
                                            onClick={() =>
                                                this.getCalculation()
                                            }
                                            primary={true}
                                        >
                                            Calcular
                                        </Button>
                                    </div>
                                    <div
                                        className="col-md-12 mb-3"
                                        style={{ top: "-27px" }}
                                    >
                                        <div className="input-box active-grey" style={{margin: "5px"}}>
                                            <label className="input-label">
                                                Observações
                                            </label>
                                            <textarea
                                                className="form-control heigh-auto"
                                                rows="3"
                                                name="Observacoes"
                                                id="Observacoes"
                                                // value={
                                                //     this.state.Observacoes == "" ? this.props.row.Observacoes : this.state.Observacoes
                                                // }
                                                // onChange={(e) =>
                                                //     this.handleChange(e)
                                                // }
                                            ></textarea>
                                            {this.state.requiredField.Obser && (
                                                <span className="text-danger">
                                                    Campo obrigatório
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Inserirvasilha;
